<template>
  <div class="desktop-view">
    <MdModal data-qa-id="ai-consent-modal" :isopen="show" showoverlay="true" labelledby="modal-title"
      describedby="modal-description" id="ai-consent-modal" bordered="true" @handleclose="$emit('cancel')"
      width="554px">
      <div data-qa-id="modal-header" slot="header" class="modal-header">
        <MdTypography data-qa-id="modal-title" tag="h5" variant="heading5--medium" textalign="center">
          {{ $t('pages.aiTextEditor.ai_consent_modal.title') }}
        </MdTypography>
        <SmartStars width="32" height="32" />
      </div>

      <div slot="body" data-qa-id="modal-body" class="modal-body">
        <div v-if="agreement.isLoading && !errorState.status" class="loader-container" data-qa-id="loader-container">
          <div v-for="(skeletonChild, index) in loadingSkeleton" :key="index" class="width-100">
            <LoadingSkeleton v-for="(skeleton, _index) in skeletonChild" :key="_index" :height="skeleton.height"
              :width="skeleton.width">
            </LoadingSkeleton>
          </div>
        </div>
        <div v-else-if="errorState.status" class="consent-error-container">
          <div data-qa-id="ai-consent-error-container" class="flex-8-gap">
            <div class="warning-icon-div">
              <WarningIcon />
            </div>
            <MdTypography data-qa-id="ai-consent-error-message" tag="p" variant="body1--regular" color="spirits--800">
              {{ errorState.message }}
            </MdTypography>
          </div>
          <div class="flex-8-gap">
            <div class="warning-icon-div">
            </div>
            <MdLink data-qa-id="ai-consent-reload-on-error" underline="false" href="javascript:void(0)"
              @click="fetchConsentAgreement">
              {{ $t('pages.aiTextEditor.ai_consent_modal.refresh') }}
              <MdIconReload slot="icon-start" size="16" showbox="false" aria-label="reload"
                :animation="agreement.isLoading?'spin-left':'none'" />
            </MdLink>
          </div>
        </div>
        <template v-else>
          <MdTypography v-for="(line, index) in agreement.text" :key="index" :data-qa-id="`modal-body-text-${index}`"
            tag="p" variant="body1--regular" color="spirits--800">
            {{ line }}
          </MdTypography>
        </template>
      </div>

      <div data-qa-id="modal-footer" slot="footer" class="modal-footer">
        <MdButton data-qa-id="cancel-button" @click="$emit('cancel')" size="large" color="lightgrey">
          {{ $t('pages.aiTextEditor.ai_consent_modal.cancel_btn') }}
        </MdButton>
        <MdButton data-qa-id="enable-ai-button" @click="agreeAction" size="large"
          :disabled="!agreement.action || inProgress">
          {{ $t('pages.aiTextEditor.ai_consent_modal.enable_btn') }}
          <MdSpinner v-show="inProgress" slot="icon-start" color="white" size="16" showbox="false"
            aria-label="Agree button" />
        </MdButton>
      </div>
    </MdModal>
  </div>

  <div data-qa-id="mobile-tablet-view" class="mobile-tablet-view" v-if="show">
    <div data-qa-id="close-btn" class="close-btn" @click="$emit('cancel')">
      <MdIconClose />
    </div>
    <div class="modal-content">
      <div class="modal-header">
        <MdTypography data-qa-id="modal-title-mobile" tag="h7" variant="heading7--medium" textalign="center">
          {{ $t('pages.aiTextEditor.ai_consent_modal.title') }}
        </MdTypography>
        <SmartStars width="24" height="24" />
      </div>
      <div class="modal-body">
        <div v-if="agreement.isLoading && !errorState.status" class="loader-container" data-qa-id="loader-container">
          <div v-for="(skeletonChild, index) in loadingSkeleton" :key="index" class="width-100">
            <LoadingSkeleton v-for="(skeleton, _index) in skeletonChild" :key="_index" :height="skeleton.height"
              :width="skeleton.width">
            </LoadingSkeleton>
          </div>
        </div>
        <div v-else-if="errorState.status" class="consent-error-container">
          <div data-qa-id="ai-consent-error-container" class="flex-8-gap">
            <div class="warning-icon-div">
              <WarningIcon />
            </div>
            <MdTypography data-qa-id="ai-consent-error-message" tag="p" variant="body1--regular" color="spirits--800">
              {{ errorState.message }}
            </MdTypography>
          </div>
          <div class="flex-8-gap">
            <div class="warning-icon-div">
            </div>
            <MdLink data-qa-id="ai-consent-reload-on-error" underline="false" href="javascript:void(0)"
              @click="fetchConsentAgreement">
              {{ $t('pages.aiTextEditor.ai_consent_modal.refresh') }}
              <MdIconReload slot="icon-start" size="16" showbox="false" aria-label="reload"
                :animation="agreement.isLoading?'spin-left':'none'" />
            </MdLink>
          </div>
        </div>
        <template v-else>
          <MdTypography v-for="(line, index) in agreement.text" :key="index"
            :data-qa-id="`modal-body-text-${index}-mobile`" tag="p" variant="body1--regular" color="spirits--800">
            {{ line }}
          </MdTypography>
        </template>
      </div>

      <div data-qa-id="modal-footer-mobile" class="modal-footer">
        <MdButton @click="$emit('cancel')" size="large" color="lightgrey" data-qa-id="cancel-button-mobile">
          {{ $t('pages.aiTextEditor.ai_consent_modal.cancel_btn') }}
        </MdButton>
        <MdButton @click="agreeAction" size="large" :disabled="!agreement.action || inProgress"
          data-qa-id="enable-ai-button-mobile">
          {{ $t('pages.aiTextEditor.ai_consent_modal.enable_btn') }}
          <MdSpinner v-show="inProgress" slot="icon-start" color="white" size="16" showbox="false"
            aria-label="Agree button" />
        </MdButton>
      </div>
    </div>
  </div>
</template>